import React, { useEffect, useState } from 'react';
import { Play, Info } from 'lucide-react';
import { IMG, titleOf } from '../lib/tmdb';

export default function Hero({ item, onPlay, onInfo }) {
  const [item2, setItem2] = useState(item);
  useEffect(() => setItem2(item), [item]);
  if (!item2) return <div className="h-[56vw] max-h-[80vh] bg-[#141414]" />;

  const overview = item2.overview || '';
  const short = overview.length > 200 ? overview.slice(0, 200) + '…' : overview;

  return (
    <div className="relative w-full h-[56vw] max-h-[85vh] min-h-[420px]">
      <img
        src={`${IMG}${item2.backdrop_path}`}
        alt={titleOf(item2)}
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 hero-fade-left" />
      <div className="absolute inset-0 hero-fade-bottom" />

      <div className="absolute bottom-[18%] left-4 md:left-12 max-w-xl z-10">
        <h1 className="text-3xl md:text-6xl font-black drop-shadow-lg mb-3 md:mb-5">
          {titleOf(item2)}
        </h1>
        <p className="hidden md:block text-sm md:text-lg text-white/90 drop-shadow-md mb-5 leading-relaxed">
          {short}
        </p>
        <div className="flex items-center gap-3">
          <button
            onClick={() => onPlay(item2)}
            className="flex items-center gap-2 bg-white text-black font-semibold px-5 md:px-8 py-2 md:py-2.5 rounded hover:bg-white/80 transition-colors"
          >
            <Play size={22} fill="black" /> Play
          </button>
          <button
            onClick={() => onInfo(item2)}
            className="flex items-center gap-2 bg-[rgba(109,109,110,0.7)] text-white font-semibold px-5 md:px-8 py-2 md:py-2.5 rounded hover:bg-[rgba(109,109,110,0.5)] transition-colors"
          >
            <Info size={22} /> More Info
          </button>
        </div>
      </div>
    </div>
  );
}